import { Route, Routes } from 'react-router-dom';
import Layout from './pages/Layout';
import PageNotFound from './pages/PageNotFound';
import Home from './pages/Home';
import Checkout from './pages/Checkout';
import Thankyou from './pages/Thankyou';
import MenuListing from './pages/MenuListing';

function App() {
    return (
        <Routes>
            <Route path='/' element={<Layout />}>
                <Route index element={<Home />} />
                <Route path='menu-listing' element={<MenuListing />} />
                <Route path='checkout' element={<Checkout />} />
                <Route path='restaurant-confirmation' element={<Thankyou />} />
            </Route>
            <Route path='page-not-found' element={<PageNotFound />}></Route>
            <Route path='*' element={<PageNotFound />}></Route>
            {/* <Route path='splashscreen' element={<SplashScreen />}></Route>
            <Route path='home' element={<HomeScreen />}></Route>
            <Route path='menulist' element={<MenuListScreen />}></Route>
            <Route path='ordermenu' element={<OrderMenuScreen />}></Route>
            <Route path='checkout' element={<CheckoutScreen />}></Route>
            <Route path='changeaddress' element={<ChangeAddress />} />
            <Route path='addNewaddress' element={<AddNewAddressScreen />} />
            <Route path='orderhistory' element={<OrderHistoryScreen />}></Route>
            <Route path='trackorder' element={<TrackOrderScreen />} />
            <Route path='login' element={<LoginScreen />}></Route>
            <Route path='thankyou' element={<ThankYouScreen />}></Route>
            <Route path='page-not-found' element={<PageNotFound />}></Route>
            <Route path='*' element={<PageNotFound />}></Route> */}
        </Routes>
    );
}

export default App;
